(() => {
  const printLinks = document.querySelectorAll('[data-wll-print-recipe]');
  if (!printLinks.length) return;

  printLinks.forEach((link) => {
    const printUrl = new URL(window.location.href);
    printUrl.searchParams.set('view', 'print');
    printUrl.searchParams.set('recipe_section', link.dataset.wllRecipeSection);
    printUrl.hash = '';
    link.href = printUrl.toString();
  });
})();
